import gameData, { GameVersions } from './gameData';

export default function setupGameConfig(variantId) {
  const config = {
    // the following options are used in Odd or Even variants only
    gametype: gametypes.both,
    senderID: null,

    // the following options are used in Multiplies variants only
    titleInstructionText: 'SELECT A MULTIPLE',
    titleInstructionTextFontSize: 62,
    introInstructionsText: 'SLICE THE MULTIPLE OF\nTHE TARGET NUMBER.',
    subtitle: 'TitleStamp',
    options: null, // null to allow all default choices, or an array of possible number choices
    gameScreenTopTextPrefix: 'MULTIPLES OF',
    showIntroScreenEachPlaythrough: false, // if true, the intro screen will be shown each time the game is played instead of only the 1st time

    // the following options are used in all variants (and the game default)
    introScreenExtraPause: false, // if true, the intro screen will sit a bit longer
    playSubtitle: false,
    saveKey: variantId
  };
  if (gameData.gameVersion === GameVersions.OddOrEven) {
    switch (variantId) {
      case 'even-a':
      case 'even-b':
        config.gametype = gametypes.even;
        config.senderID = 'Even';
        break;
      case 'odd-a':
      case 'odd-b':
        config.gametype = gametypes.odd;
        config.senderID = 'Odd';
        break;
      default:
        config.playSubtitle = true;
        config.saveKey = '';
        break;
    }
  }
  else if (gameData.gameVersion === GameVersions.Multiples) {
    switch (variantId) {
      case 'divisibility-rules-a': // 3rd grade
        config.titleInstructionText = 'SELECT A NUMBER TO DIVIDE BY.';
        config.introInstructionsText = 'SLICE THE NUMBERS\nTHAT ARE DIVISIBLE BY:';
        config.subtitle = 'Variants/Subtitle';
        config.options = [2, 5, 10];
        config.introScreenExtraPause = true;
        config.gameScreenTopTextPrefix = 'DIVISIBLE BY';
        config.showIntroScreenEachPlaythrough = true;
        break;
      case 'divisibility-rules-b': // 4th grade
        config.titleInstructionText = 'SELECT A NUMBER TO DIVIDE BY.';
        config.introInstructionsText = 'SLICE THE NUMBERS\nTHAT ARE DIVISIBLE BY:';
        config.subtitle = 'Variants/Subtitle';
        config.options = [2, 3, 5, 9, 10];
        config.introScreenExtraPause = true;
        config.gameScreenTopTextPrefix = 'DIVISIBLE BY';
        config.showIntroScreenEachPlaythrough = true;
        break;
      case 'divisibility-rules-c': // 5th grade
        config.titleInstructionText = 'SELECT A NUMBER TO DIVIDE BY.';
        config.titleInstructionTextFontSize = 48;
        config.introInstructionsText = 'SLICE THE NUMBERS\nTHAT ARE DIVISIBLE BY:';
        config.subtitle = 'Variants/Subtitle';
        config.options = [2, 3, 4, 5, 6, 9, 10];
        config.introScreenExtraPause = true;
        config.gameScreenTopTextPrefix = 'DIVISIBLE BY';
        config.showIntroScreenEachPlaythrough = true;
        break;
      default:
        config.playSubtitle = true;
        config.saveKey = '';
        break;
    }
  }
  else {
    config.saveKey = '';
    config.playSubtitle = true;
  }
  return config;
}

export const gametypes = {
  both: 'both',
  odd: 'odd',
  even: 'even'
};